import styled from 'styled-components';

export const StudentRetaketationWrapper = styled.div``;

export const RetakeStudentStyled = styled.div`
  .ant-picker.ant-picker-outlined {
    width: 400px !important;

    .ant-divider-horizontal {
      margin-bottom: 16px !important;
    }
  }
`;

export const ErrorMessage = styled.div`
  width: 400px;
  height: ${(props) => (props.message ? '20px' : '0px')};
  color: #ff4d4f;
`;
